import { Select as a, selectClasses as o, menuItemClasses as n, inputLabelClasses as s } from "@mui/material";
import { styled as l, css as i } from "./styled2.mjs";
import { FormControl as p } from "./index49.mjs";
const d = l(a)`
	background: ${({ theme: t }) => t.palette.background.level1};
	height: ${({ theme: t, $size: e }) => e === "small" ? t.spacing(4.5) : t.spacing(6.5)};

	.${o.select} {
		display: flex;
		align-items: center;

		padding-block: ${({ $size: t }) => t === "small" ? "6.5px !important" : "14.5px !important"};

		${({ $withChips: t, $hasValue: e, $size: r }) => {
  if (t && e)
    return i`
					padding-block: ${r === "small" ? "2px !important" : "10px !important"};
				`;
}};
	}

	.${n.root} {
		padding: ${({ theme: t }) => t.spacing(0)};
		margin: ${({ theme: t }) => t.spacing(0)};
		gap: ${({ theme: t }) => t.spacing(0)};

		color: ${({ theme: t }) => t.palette.text.primary};
	}
`, $ = l(p)`
	.${s.shrink} {
		transform-origin: center left;
	}
`;
export {
  $ as StyledFormControl,
  d as StyledSelect
};
//# sourceMappingURL=styles66.mjs.map
